import { useRef } from 'react';
import useCountUp from '../hooks/useCountUp';
import useScrollReveal from '../hooks/useScrollReveal';

const stats = [
  { value: 500, suffix: '+', label: 'Fleets Managed' },
  { value: 12000, suffix: '+', label: 'Loads Tracked' },
  { value: 99.9, suffix: '%', label: 'Uptime', isDecimal: true },
  { value: 4.8, suffix: '/5', label: 'User Rating', isDecimal: true },
];

const logos = [
  'Midwest Express',
  'Atlantic Freight',
  'Chen Transport',
  'Pacific Fleet',
  'Summit Logistics',
  'Heartland Carriers',
];

function StatItem({ value, suffix, label, isDecimal, isActive }) {
  const count = useCountUp(isDecimal ? Math.round(value * 10) : value, 1500, isActive);
  const display = isDecimal ? (count / 10).toFixed(1) : count.toLocaleString();

  return (
    <div className="flex flex-col items-center text-center">
      <span className="font-mono text-4xl md:text-5xl font-bold text-gray-900">
        {display}
        {suffix}
      </span>
      <span className="text-sm text-gray-500 uppercase tracking-wider mt-1">{label}</span>
    </div>
  );
}

export default function StatsBar() {
  const sectionRef = useRef(null);
  const isVisible = useScrollReveal(sectionRef, { threshold: 0.2 });

  return (
    <section className="bg-white border-y border-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-6" ref={sectionRef}>
        {/* Stats grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
          {stats.map((stat) => (
            <StatItem key={stat.label} {...stat} isActive={isVisible} />
          ))}
        </div>

        {/* Company logos */}
        <div className="flex flex-wrap justify-center gap-4">
          {logos.map((name) => (
            <div
              key={name}
              className="
                px-5 py-3 rounded-lg bg-gray-100 text-gray-400 text-sm font-medium
                filter grayscale
                hover:grayscale-0 hover:bg-blue-50 hover:text-blue-600
                transition-all duration-200 cursor-default select-none
              "
            >
              {name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
